import React from 'react';
import { cn } from '@/lib/utils';

type SectionProps = {
  className?: string;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLElement>;

function Section({className, children}: SectionProps) {
  return (
    <section className={cn("w-full max-w-7xl text-zinc-800", className)}>
      {children}
    </section>
  );
}

export default Section;